<strong class="small-title small-title--color-{{ color }}">
  <ng-content></ng-content>
</strong>
